import axios from "axios";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { authAPI, getConfig, searchAPI } from "../../apis";
import ButtonPrimary from "../../components/button/ButtonPrimary";
import InputCheckbox from "../../components/input/InputCheckbox";
import InputPassword from "../../components/input/InputPassword";
import InputText from "../../components/input/InputText";
import {
  emailValidation,
  notEmptyValidation,
  validateUserPassword,
} from "../../functions/validation";
import { loginUser } from "../../redux/features/authSlice";
import { setsidebarData } from "../../redux/features/dataSlice";

const ForgotPassword = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [firstName, setfirstName] = useState("");

  const [lastName, setlastName] = useState("");

  const [email, setemail] = useState("");
  const [password, setpassword] = useState("");
  const [confirmPassword, setconfirmPassword] = useState("");
  const [tc, settc] = useState(false);
  const [loading, setloading] = useState(false);

  async function onSubmitLogin(e) {
    e.preventDefault();
    // if (!notEmptyValidation(firstName) || !notEmptyValidation(lastName)) {
    //   toast.error("Please fill out all the fields");
    //   return;
    // }

    if (!emailValidation(email)) {
      toast.error("Please enter a valid E-mail");
      return;
    }
    // if (!validateUserPassword(password)) {
    //   toast.error("Please enter a valid password");
    //   return;
    // }

    // if (password !== confirmPassword) {
    //   toast.error("Password do not match");
    //   return;
    // }
    // if (!tc) {
    //   toast.error("Please accept our terms");
    //   return;
    // }
    try {
      setloading(true);
      const res = await axios.post(authAPI.forgotPassword, {
        email,
      });
      setloading(false);

      if (res.data) {
        localStorage.setItem("email", email);
        navigate("/ResetPasswordMessage");
      }
    } catch (error) {
      if (error.response.data === "User not found"){
        toast.error(error.response.data);
      } 
      console.log(error);
      toast.error(error.response.data.title);
      setloading(false);
    }
  }

  return (
    <form onSubmit={onSubmitLogin}>
      <h1>Forgot Password</h1>

      <InputText
        placeholder="Email address"
        validation="email"
        value={email}
        onChange={(e) => setemail(e.target.value)}
      />

      <ButtonPrimary text="Continue" loading={loading} />

      <p className="fp" onClick={() => navigate("/signin")}>
        Go back to Sign In
      </p>
    </form>
  );
};

export default ForgotPassword;
